import React, { useState } from "react";

import seal from "../../assets/Background.png";
import CTA from "../../components/cta/cta";
import two from "../../assets/two.jpg";
import one from "../../assets/one.webp";
import fire from "../../assets/fire.jpg";
import hose from "../../assets/hose.jpg";
import truck from "../../assets/truck.webp";
import hero from "../../assets/hero.jpeg";

const Hero = () => {
    const [hoveredImage, setHoveredImage] = useState(null);

    const handleMouseEnter = (imageName) => {
        setHoveredImage(imageName);
    };

    const handleMouseLeave = () => {
        setHoveredImage(null);
    };


    return (
        <div className="relative overflow-hidden bg-[#e4e4f1] pt-5 text-center pb-64">
            {/* Background Image */}
            <img
                src={hero}
                alt="Background"
                className="absolute inset-0 w-full h-full object-cover opacity-50 grayscale md:grayscale-0"
            />

            {/* Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-b from-white via-transparent to-white z-0" />

            {/* Content */}
            <div className="relative z-10">
                <img
                    src={seal}
                    alt="WPFFA Seal"
                    className="w-[200px] h-[200px] md:w-[300px] md:h-[300px] mt-[150px] mx-auto"
                />
                <h1 className="text-[2.5em] md:text-[4em] mb-2.5">Where Generosity Meets Action</h1>
                <p className="text-[1em] md:text-[1.5em] mb-5">Together we can help shape brighter futures.</p>
                <div className="hidden md:block">
                    <CTA />
                </div>

                <div className="mt-[100px] flex justify-center">
                    <img
                        className="rounded-[15px] border-4 md:border-8 border-white shadow-[0_10px_10px_rgba(0,0,0,0.1)] transition-transform duration-100 ease-in-out h-[50px] md:h-[150px]"
                        src={two}
                        alt="Firefighters in front of Waco firetruck"
                        style={{
                            transform: hoveredImage === 'two' ? 'rotate(0deg) scale(1.5)' : "rotate(5deg) scale(1)",
                            zIndex: hoveredImage === 'two' ? 1 : 0
                        }}
                        onMouseEnter={() => handleMouseEnter('two')}
                        onMouseLeave={handleMouseLeave}
                    />
                    <img
                        className="rounded-[15px] border-4 md:border-8 border-white shadow-[0_10px_10px_rgba(0,0,0,0.1)] transition-transform duration-100 ease-in-out h-[50px] md:h-[150px]"
                        src={one}
                        alt="Firefighters in action"
                        style={{
                            transform: hoveredImage === 'one' ? 'rotate(0deg) scale(1.5)' : "rotate(-7deg) scale(1)",
                            zIndex: hoveredImage === 'one' ? 1 : 0
                        }}
                        onMouseEnter={() => handleMouseEnter('one')}
                        onMouseLeave={handleMouseLeave}
                    />
                    <img
                        className="rounded-[15px] border-4 md:border-8 border-white shadow-[0_10px_10px_rgba(0,0,0,0.1)] transition-transform duration-100 ease-in-out h-[50px] md:h-[150px]"
                        src={fire}
                        alt="Fire scene"
                        style={{
                            transform: hoveredImage === 'fire' ? 'rotate(0deg) scale(1.5)' : "rotate(3deg) scale(1)",
                            zIndex: hoveredImage === 'fire' ? 1 : 0
                        }}
                        onMouseEnter={() => handleMouseEnter('fire')}
                        onMouseLeave={handleMouseLeave}
                    />
                    <img
                        className="rounded-[15px] border-4 md:border-8 border-white shadow-[0_10px_10px_rgba(0,0,0,0.1)] transition-transform duration-100 ease-in-out h-[50px] md:h-[150px]"
                        src={hose}
                        alt="Firefighter using a hose"
                        style={{
                            transform: hoveredImage === 'hose' ? 'rotate(0deg) scale(1.5)' : "rotate(-5deg) scale(1)",
                            zIndex: hoveredImage === 'hose' ? 1 : 0
                        }}
                        onMouseEnter={() => handleMouseEnter('hose')}
                        onMouseLeave={handleMouseLeave}
                    />
                    <img
                        className="rounded-[15px] border-4 md:border-8 border-white shadow-[0_10px_10px_rgba(0,0,0,0.1)] transition-transform duration-100 ease-in-out h-[50px] md:h-[150px]"
                        src={truck}
                        alt="Fire truck"
                        style={{
                            transform: hoveredImage === 'truck' ? 'rotate(0deg) scale(1.5)' : "rotate(10deg) scale(1)",
                            zIndex: hoveredImage === 'truck' ? 1 : 0
                        }}
                        onMouseEnter={() => handleMouseEnter('truck')}
                        onMouseLeave={handleMouseLeave}
                    />
                </div>
            </div>
        </div>
    );
};

export default Hero;
